import React from "react";
import { formatRelativeTimestampProps } from "./platformAdminPage.utils";

const PaRelativeTime = ({ value }) => {
  const props = formatRelativeTimestampProps(value);

  if (!props.dateTime) {
    return <span>{props.children}</span>;
  }

  return <time dateTime={props.dateTime} title={props.title}>{props.children}</time>;
};

export default PaRelativeTime;
